const getDelphiNumber = (item: any): string => {
  const ids = item && typeof item.objectDb === "number" ? `${item.objectId}/${item.objectDb}` : "";
  return ids !== "0/0" ? ids : "";
};

export default getDelphiNumber;
